import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Table, Row } from 'react-bootstrap';
import Card from '../Card/Card';

// Static Data
const WORD_PAIRS = [
  "Belo - Crno", "Plač - Smeh", "Poravnati - Izravnati", "Tanak - Vitak",
  "Zaspati - probuditi", "Dozvoliti - Odbiti", "Umiriti - Smiriti", "Blaženstvo - Nevolja",
  "Sakupiti - Grupisati", "Kepec - Patuljak", "Iscepati - Poderati", "Sazvati - Rasturiti",
  "Obazriv - Nesmotren", "Prijatelj - Neprijatelj", "Uprljati - Očistiti", "Ljubazan - Osoran",
  "Primiti - Uzeti", "Protivrečiti - Saglasiti", "Zamor - Osveženje", "Čitav - Iscepan",
  "Važan - Beznačajan", "Krotak - Nepokoran", "Oskudica - Nemaština", "Moliti - Preklinjati",
  "Odmana - Prevara", "Optužiti - Okriviti", "Dodati - Priključiti", "Molba - Preklinjanje",
  "Povezati - Spojiti", "Kratkovid - Dalekovid", "Pokretan - Učvršćen", "Glavni - Bitan",
  "Pokoran - Poslušan", "Raspikuća - Čuvaran", "Uporan - Istrajan", "Pokuda - Pogrda",
  "Zavisan - Nesamostalan", "Koristan - Unosan", "Nepopustljiv - Tvrdoglav", "Predgovor - Pogovor"
];

// Inline Styles
const styles = {
  div1: { display: "flex", justifyContent: "center", alignItems: "center", height: "inherit", padding: "3px" },
  div2: { width: "80%", height: "80%", background: "#fff", boxShadow: "15px 15px 25px #ccc", borderRadius: "15px" },
  centerText: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  labelFont: { fontSize: '15px' }
};

const IntTestTwo = () => {
  const history = useHistory();
  const auth = useSelector(state => state.auth);

  // Initialize all 40 answers to '0'
  const [answers, setAnswers] = useState(() =>
    WORD_PAIRS.reduce((acc, _, index) => ({ ...acc, [`P${index + 1}`]: '0' }), {})
  );

  // Initial timer setup: 2 minutes 3 seconds = 123 seconds
  const [timeLeft, setTimeLeft] = useState(123);

  // Reusable API submission handler
  const submitTest = useCallback(async (isAutoSubmit = false) => {
    try {
      const resp = await axios.post('/api/intApi/saveTestIIResult', answers);
      await Swal.fire(
        isAutoSubmit ? 'Niste na vreme završili test, ali su rezultati poslati!' : 'Poslato!',
        resp.data.message,
        resp.data.sign
      );
      history.push('/introIntTest');
    } catch (err) {
      console.error(err);
    }
  }, [answers, history]);

  // Handle radio input changes
  const onChange = (e) => {
    const { name, value } = e.target;
    setAnswers(prev => ({ ...prev, [name]: value }));
  };

  // Handle manual submit
  const onSubmit = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Da li sigurno želiš da predaš test?',
      text: 'Nećeš moći da ga radiš ponovo',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ček da proverim',
      confirmButtonText: 'Predaj!'
    }).then((result) => {
      if (result.isConfirmed) {
        submitTest(false);
      }
    });
  };

  // Access check on mount
  useEffect(() => {
    const checkAccess = async () => {
      try {
        const resp = await axios.post('/api/intApi/checkIfTestIsAccessed/', { whatTest: 'intII' });
        if (resp.data.message === true) {
          await Swal.fire('Problem', 'Test je već rađen sa ovog naloga!', 'error');
          history.push('/introIntTest');
        }
      } catch (err) {
        console.error(err);
      }
    };
    checkAccess();
  }, [history]);

  // Timer interval handling
  useEffect(() => {
    if (timeLeft <= 0) {
      submitTest(true);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, submitTest]);

  // Format seconds into MM:SS
  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div className="content">
      <div style={{ position: 'fixed' }}>
        <Card content={<Row>Vreme: {formatTime(timeLeft)}</Row>} />
      </div>

      <div style={styles.div1}>
        <div style={styles.div2}>
          <div style={{ textAlign: 'center', margin: '24px 50px 12px' }}>
            <div style={{ padding: '16px 0', textAlign: 'left' }}>
              <br /><br />
              <div style={styles.centerText}>
                Zdravo {auth?.user?.name}, pred tobom je drugi deo testa sposobnosti, srećno!
              </div>
              <br />
              <div style={styles.centerText}>
                <Table striped bordered hover variant="grey" style={{ width: '45%' }}>
                  <thead>
                    <tr>
                      <th>Par</th>
                      <th>Isto</th>
                      <th>Suprotno</th>
                    </tr>
                  </thead>
                  <tbody>
                    {WORD_PAIRS.map((pair, index) => {
                      const paramName = `P${index + 1}`;
                      return (
                        <tr key={paramName}>
                          <td>{index + 1}. {pair}</td>
                          <td>
                            <div className="form-check">
                              <label style={styles.labelFont}>
                                <input
                                  onChange={onChange}
                                  type="radio"
                                  name={paramName}
                                  value="1"
                                  checked={answers[paramName] === '1'}
                                  className="form-check-input"
                                /> 1
                              </label>
                            </div>
                          </td>
                          <td>
                            <div className="form-check">
                              <label style={styles.labelFont}>
                                <input
                                  onChange={onChange}
                                  type="radio"
                                  name={paramName}
                                  value="2"
                                  checked={answers[paramName] === '2'}
                                  className="form-check-input"
                                /> 2
                              </label>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              <div style={styles.centerText}>
                <input
                  type="submit"
                  value="Predaj test"
                  onClick={onSubmit}
                  className="btn-fill col-md-3 pull-center btn btn-info"
                  style={{ margin: '3px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntTestTwo;